import { ADICIONAR_FILTRO_MDFE, LIMPAR_FILTRO_MDFE, LISTAR_FILTROS_MDFE, REMOVER_FILTRO_MDFE } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initial = {}

export const filtrosAdicionadosMdfe = (state = [], action = undefined) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_MDFE: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }
    case REMOVER_FILTRO_MDFE: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }
    case LIMPAR_FILTRO_MDFE: {
      return []
    }
    default:
      return state
  }
}

export const filtrosMdfe = (state = initial, action = undefined) => {
  switch (action.type) {
    case LISTAR_FILTROS_MDFE: {
      return action.payload.data
    }
    default:
      return state
  }
}
